import React from 'react';

/**
 * The YouTube play badge in brand red. lucide's <Youtube/> is a thin outline
 * that reads as "some video thing" at small sizes; people recognise the solid
 * red badge instantly, which is the whole point of putting it on the hero —
 * it tells a first-time visitor, without a sentence, that a YouTube link is a
 * valid thing to paste here.
 */
export default function YouTubeMark({ size = 20, className = '', title = 'YouTube' }) {
  return (
    <svg
      width={size}
      height={size * (24 / 24)}
      viewBox="0 0 24 24"
      className={className}
      role="img"
      aria-label={title}
    >
      <path
        fill="#FF0000"
        d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.3 31.3 0 0 0 0 12a31.3 31.3 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.3 31.3 0 0 0 24 12a31.3 31.3 0 0 0-.5-5.8z"
      />
      <path fill="#fff" d="M9.6 15.6 15.8 12 9.6 8.4z" />
    </svg>
  );
}
